export default __webpack_public_path__ + "static/media/lung-function.b9c455e8.svg";